//https://firebase.google.com/docs/storage/web/upload-files#full_example
'use strict';
import { getStorage, ref, uploadBytes,getDownloadURL,uploadBytesResumable,uploadString } from "firebase/storage";



export async function uploadFile1(file){
    
    var userId=document.getElementById("googleUserId").value;
    //
    const storage = getStorage();
    const storageRef = ref(storage, userId + '/'+'test');
    //
    const metadata = {
        contentType: 'image/jpeg',
      };
      
    //   const storageRef = ref(storage, 'images/' + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);

    document.getElementById("confirmBtn").style="display:block;"
    document.getElementById("promptDetailDialog").showModal();

    // Listen for state changes, errors, and completion of the upload.
    var uploadImgUrl=''
    uploadTask.on('state_changed',
    (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        if (typeof promptDetailDialog.showModal === "function") {
          
            document.getElementById("promptP1").innerHTML = 'Upload is ' + Math.floor(progress) + '%';
            document.getElementById("promptP2").innerHTML = ''
            
          }
        switch (snapshot.state) {
        case 'paused':
            console.log('Upload is paused');
            break;
        case 'running':
            console.log('Upload is running');
            break;
        }
    }, 
    (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
            case 'storage/unauthorized':
            // User doesn't have permission to access the object
                alert('uploadFile() err: storage/unauthorized')
                break;
            case 'storage/canceled':
            // User canceled the upload
                alert('uploadFile() err: storage/canceled')
                break;
    
            // ...
    
            case 'storage/unknown':
                alert('uploadFile() err: storage/unknown')
            // Unknown error occurred, inspect error.serverResponse
                break;
        }
    }, 
    async () => {
        // Upload completed successfully, now we can get the download URL
        uploadImgUrl=await getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        console.log('File available at', downloadURL);
        document.getElementById('initFileUrl').value=downloadURL;
        return downloadURL;
        });
    }
    );

return uploadImgUrl;
    
}

export async function uploadFile2(file){
    

    const storage = getStorage();
    const storageRef = ref(storage, 'test2');
    //
    const metadata = {
        contentType: 'image/jpeg',
      };
      
    //   const storageRef = ref(storage, 'images/' + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);

    var downloadURL=''
    // Listen for state changes, errors, and completion of the upload.
    var uploadImgUrl=await uploadTask.on('state_changed',
    (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
        case 'paused':
            console.log('Upload is paused');
            break;
        case 'running':
            console.log('Upload is running');
            break;
        }
    }, 
    (error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
            case 'storage/unauthorized':
            // User doesn't have permission to access the object
                alert('uploadFile() err: storage/unauthorized')
                break;
            case 'storage/canceled':
            // User canceled the upload
                alert('uploadFile() err: storage/canceled')
                break;
    
            // ...
    
            case 'storage/unknown':
                alert('uploadFile() err: storage/unknown')
            // Unknown error occurred, inspect error.serverResponse
                break;
        }
    }, 
    () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        console.log('File available at', downloadURL);
        return downloadURL;
        });
    }
    );

    
return uploadImgUrl;
}

export async function uploadImgBase64(file){
    
    var userId=document.getElementById("googleUserId").value;
    const storage = getStorage();
    const storageRef = ref(storage, userId + '/'+'test');
    //
    const metadata = {
        contentType: 'image/jpeg',
      };

    const uploadTask = await uploadString(storageRef, file, 'data_url',metadata)
    // .then(async (snapshot) => {
    //     await getDownloadURL(storageRef).then(url => {
    //         console.log('Download URL', url);
    //         document.getElementById('initFileUrl').value=downloadURL;
    //     })
    //   });

    // document.getElementById("confirmBtn").style="display:block;"
    // document.getElementById("promptDetailDialog").showModal();
    // document.getElementById("promptP1").innerHTML = 'Upload is 0%';

    const downloadURL = await getDownloadURL(storageRef)
    console.log('Download URL', downloadURL)
    document.getElementById('initFileUrl').value=downloadURL;
    //
    // document.getElementById("promptDetailDialog").close();
    // document.getElementById("confirmBtn").style="display:none;"
    
}